export default "__VITE_ASSET__CpS7NCCo__"